import { defineStore } from 'pinia';
import api from '@/services/api';
import deposito_model from '@/shared/models/deposito_model';
import { getParamsUrl } from './deposito_utils';

export const useDepositoStore = defineStore('depositoStore', {
  state: () => ({
    entity: 'deposito',
    depositos: [],
    deposito: { ...deposito_model },
    page: 1,
    filters: {},
  }),
  getters: {},
  actions: {
    async findAllDepositoHTTP(params) {
      return await api.get(
        `/${this.entity}?${getParamsUrl({ page: +this.page, Activo: true, ...this.filters, ...params })}`,
      );
    },
    async findAllDeposito(params) {
      const result = await this.findAllDepositoHTTP(params);
      if (result && result.data.length > 0) {
        this.depositos.push(...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    async findAllDepositoAndReturn(params) {
      const result = await this.findAllDepositoHTTP(params);
      if (result) {
        return result.data;
      }
      return [];
    },
    async saveDeposito() {
      if (this.deposito.Codigo) {
        return await this.updateDepositoHTTP();
      } else {
        return await this.createDepositoHTTP();
      }
    },
    async createDepositoHTTP() {
      return await api.post(`/${this.entity}`, this.deposito);
    },
    async updateDepositoHTTP() {
      return await api.patch(`/${this.entity}/${this.deposito.Codigo}`, this.deposito);
    },
    async deleteDepositoHTTP(deposito) {
      return await api.patch(`/${this.entity}/${deposito.Codigo}`, { ...deposito, Activo: false });
    },
    cleanDeposito() {
      this.deposito = { ...deposito_model };
    },
    setPage(page) {
      this.page = page;
    },
    async firstRequest() {
      this.setPage(1);
      this.emptyList();
      await this.findAllDeposito();
    },
    emptyList() {
      this.depositos = [];
    },
  },
});
